// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const StyledButtonWrapper = styled.div`
  box-sizing: border-box;
  border-radius: 20px;
  border: 2px solid ${(props) => props.theme.colorPalette.gray[500]};
  background: ${(props) => props.theme.colorPalette.gray[300]};
  overflow: hidden;
`;

export const StyledButton = styled.button`
  box-sizing: border-box;
  border: unset;
  cursor: pointer;

  &.first-option-button {
    padding: 11px 9px 11px ${(props) => props.theme.spacing.ELEM_SPACING.REG};
  }

  &.second-option-button {
    padding: 11px 13px 11px 9px;
  }

  :disabled {
    cursor: unset;
    padding: 11px 13px 11px ${(props) => props.theme.spacing.ELEM_SPACING.REG};
    position: relative;
    border-radius: 20px;
    outline: 2px solid ${(props) => props.theme.colorPalette.gray[500]};
    background: ${(props) => props.theme.colors.WHITE};
  }

  &:disabled .toggle-button-label {
    color: ${(props) => props.theme.colorPalette.gray[800]};
  }
`;

export const StyledButtonLabelWrapper = styled.span`
  display: flex;
  align-items: center;
  column-gap: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
`;

export const StyleButtonLabel = styled(BodyCopy)`
  color: ${(props) => props.theme.colorPalette.gray[600]};
  text-transform: capitalize;
`;
